import { render } from "./SimpleFeature.vue?vue&type=template&id=f4aa5688"
import script from "./SimpleFeature.vue?vue&type=script&lang=js"
export * from "./SimpleFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__